import moment from "moment-timezone";

/**
 * get default session date time
 * by default use next day's 9:00 AM
 */
export function getDefaultSessionDateTime(timezone: string) {
  return moment().tz(timezone).add(1, "day").startOf("day").hour(9);
}
